var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Component to show a field for display (view, edit & list)
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useLogger } from "@/utils/loggerService";
import { useTranslation } from "react-i18next";
import { useDeleteRelationshipMutation, useGetModuleBuilderLayoutQuery, useGetModuleFieldsQuery, useGetModuleSubpanelDataQuery, useSaveRecordMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faCaretDown, faChevronDown, faChevronUp, faClose, faPen, faTrash, } from "@fortawesome/pro-solid-svg-icons";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Pagination } from "@/components/dev/pagination";
import copy from "fast-copy";
import { usePopup } from "@/hooks/layout";
import { setWidgetDisplay } from "@/store/layoutSlice";
import { useAppDispatch } from "@/hooks/store";
import { LayoutComponentDisplay } from "@/components/forms/components/layout/layoutComponentDisplay";
import { FieldViewType, screenViewType } from "@/components/fields/viewType";
import { validateRecord, } from "@/utils/validations/validationRules";
import Grid from "@toast-ui/react-grid";
import "tui-grid/dist/tui-grid.css";
import TuiGrid from "tui-grid";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import DisplayField from "@/components/fields/displayField";
import store from "@/store";
import { mapFieldMetaData, tableOptions } from "..";
import { translateLabel } from "@/utils/funcs";
// global callback registry (outside Redux)
export var popupCallbackRegistry = {};
export default function SubpanelDisplay(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h;
    var moduleName = _a.moduleName, recordId = _a.recordId, subpanelId = _a.subpanelId, subpanelMeta = _a.subpanelMeta, moduleStrings = _a.moduleStrings, parentModuleStrings = _a.parentModuleStrings, itemsPerPage = _a.itemsPerPage, onEditClick = _a.onEditClick, topButtons = _a.topButtons, useTab = _a.useTab;
    var logger = useLogger().logger;
    var t = useTranslation(["common"]).t;
    var tUnsafe = t;
    var tuiref = useRef(null);
    var _j = useState("desc"), sortedParams = _j[0], setSortedParams = _j[1];
    var _k = useState(""), orderBy = _k[0], setOrderBy = _k[1];
    // Load subpanels
    var _l = useGetModuleSubpanelDataQuery({
        moduleName: moduleName,
        recordId: recordId,
        subpanels: subpanelId,
        order: orderBy,
        sort: sortedParams,
    }), subpanelDataList = _l.data, isLoading = _l.isLoading, isFetchingSubpanel = _l.isFetching, refetch = _l.refetch;
    var _m = useState([]), subpanelData = _m[0], setSubpanelData = _m[1];
    useEffect(function () {
        if (subpanelDataList === null || subpanelDataList === void 0 ? void 0 : subpanelDataList.data) {
            setSubpanelData(subpanelDataList.data);
        }
    }, [subpanelDataList]);
    var meta = (((_b = subpanelData[subpanelId]) === null || _b === void 0 ? void 0 : _b.meta) && ((_c = subpanelData[subpanelId]) === null || _c === void 0 ? void 0 : _c.meta)) || {};
    var list = (((_d = subpanelData[subpanelId]) === null || _d === void 0 ? void 0 : _d.list) && ((_e = subpanelData[subpanelId]) === null || _e === void 0 ? void 0 : _e.list)) || [];
    //let subModule = meta?.module ? meta?.module : "";
    var _o = useState((meta === null || meta === void 0 ? void 0 : meta.module) ? meta === null || meta === void 0 ? void 0 : meta.module : ""), subModule = _o[0], setSubModule = _o[1];
    useEffect(function () {
        setSubModule(meta === null || meta === void 0 ? void 0 : meta.module);
    }, [meta === null || meta === void 0 ? void 0 : meta.module]);
    // Si groupe de module on prend le premier module dans la liste des sous-module
    var mModule = Array.isArray(subModule) ? subModule[0] : subModule;
    var mod_strings = (meta === null || meta === void 0 ? void 0 : meta.modStrings) ? meta === null || meta === void 0 ? void 0 : meta.modStrings : [];
    // Pagination
    var _p = useState(copy(list)), newRecord = _p[0], setNewRecord = _p[1];
    var _q = useState(0), currentPage = _q[0], setCurrentPage = _q[1];
    var handlePagination = function (e) {
        setCurrentPage(e.selected);
    };
    var perPage = 4;
    var perPageOptions = perPage;
    useEffect(function () {
        (list === null || list === void 0 ? void 0 : list.length) > 0 && setNewRecord(paginate(list, perPage, currentPage + 1));
    }, [currentPage, list]);
    var data = newRecord || [];
    var CellRendererClass = /** @class */ (function () {
        function CellRendererClass(props) {
            var rootDom = document.createElement("div");
            rootDom.style.overflow = "hidden";
            this.el = rootDom;
            this.root = createRoot(this.el);
            this.render(props);
        }
        CellRendererClass.prototype.getElement = function () {
            return this.el;
        };
        CellRendererClass.prototype.render = function (props) {
            var _a;
            var element = (_jsx(_Fragment, { children: _jsx(Provider, __assign({ store: store }, { children: _jsx(DisplayField, { record: data[props.rowKey] || {}, moduleName: (_a = data[props.rowKey]) === null || _a === void 0 ? void 0 : _a.module_name, fieldName: props.columnInfo.name, viewType: FieldViewType.LIST, fieldLabel: props.columnInfo.header, fieldMetadata: field_defs[props.columnInfo.name] || [], hideLabel: true, className: "px-2", labelClassName: "font-medium", isOnStudio: false, fieldDef: field_defs[props.columnInfo.name] &&
                            field_defs[props.columnInfo.name].type === "varchar" &&
                            field_defs[props.columnInfo.name].group &&
                            field_defs[props.columnInfo.name].group !== "email1"
                            ? field_defs
                            : {} }) })) }));
            this.root.render(element);
        };
        return CellRendererClass;
    }());
    var ButtonCellRenderer = /** @class */ (function () {
        function ButtonCellRenderer(props) {
            this.el = document.createElement("div");
            this.root = createRoot(this.el);
            this.render(props);
        }
        ButtonCellRenderer.prototype.getElement = function () {
            return this.el;
        };
        ButtonCellRenderer.prototype.render = function (props) {
            var _this = this;
            var value = props.value;
            var handleClick = function () { return __awaiter(_this, void 0, void 0, function () {
                var result, rowKey_1, link_moduleName, rowKey_2, link_moduleName;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!(value === "Supprimer")) return [3 /*break*/, 2];
                            return [4 /*yield*/, showPopup({
                                    type: "dev/popup/confirm",
                                    payload: {
                                        title: t("app.NTC_REMOVE_CONFIRMATION"),
                                        content: " ",
                                        buttons: {
                                            confirm: "Oui",
                                            cancel: "Non",
                                        },
                                    },
                                })];
                        case 1:
                            result = _e.sent();
                            if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                                rowKey_1 = props.rowKey;
                                link_moduleName = (_a = data.find(function (obj) { var _a; return obj.id === ((_a = data[rowKey_1]) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.module_name;
                                deleteRelationship(link_moduleName, (_b = data[rowKey_1]) === null || _b === void 0 ? void 0 : _b.id);
                                closePopup("null", "null");
                                setLoad(true);
                            }
                            else {
                                closePopup("null", "null");
                                setLoad(false);
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            if (value === "Editer") {
                                rowKey_2 = props.rowKey;
                                link_moduleName = (_c = data.find(function (obj) { var _a; return obj.id === ((_a = data[rowKey_2]) === null || _a === void 0 ? void 0 : _a.id); })) === null || _c === void 0 ? void 0 : _c.module_name;
                                if (link_moduleName) {
                                    navigate("/modules/".concat(link_moduleName, "/EditView/").concat((_d = data[rowKey_2]) === null || _d === void 0 ? void 0 : _d.id, "?parent_module=").concat(moduleName));
                                }
                            }
                            else {
                                alert("Button ".concat(value, " clicked!"));
                            }
                            _e.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            var button = function () {
                if (value === "Editer") {
                    return (_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: handleClick, title: value }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400 pl-2" }) })));
                }
                else if (value == "Supprimer") {
                    return (_jsx("button", __assign({ className: "p-1", onClick: handleClick, title: value }, { children: _jsx(FontAwesomeIcon, { icon: faTrash, className: "text-gray-400 pl-2" }) })));
                }
                else if (value == "Fermer") {
                    return (_jsx("button", __assign({ className: "hover:bg-gray-200 p-1 rounded-md", onClick: handleClick, title: value }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "text-gray-400 px-2" }) })));
                }
            };
            this.root.render(button());
        };
        return ButtonCellRenderer;
    }());
    /**SORT */
    var sort = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"sort\" class=\"svg-inline--fa fa-sort text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><path fill=\"currentColor\" d=\"M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z\"></path></svg>";
    var sortUp = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-up\" class=\"svg-inline--fa fa-sort-up text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 320c0 8.3 3.3 16.5 9.4 22.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8C.8 311.7 0 315.9 0 320zm109.3 32l101.5 0L160 402.7 109.3 352z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z\"></path></g></svg>";
    var sortDown = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-down\" class=\"svg-inline--fa fa-sort-down text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 192c0 4.1 .8 8.3 2.4 12.2c5 12 16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C3.3 175.5 0 183.7 0 192zm109.3-32L160 109.3 210.7 160l-101.5 0z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z\"></path></g></svg>";
    var GetHeaderClass = /** @class */ (function () {
        function GetHeaderClass(props) {
            var columnInfo = props.columnInfo || {};
            var colName = columnInfo.childNames[0] || "";
            var el = document.createElement("div");
            el.style.cssText =
                "display: flex;flex-direction: row;justify-content: space-between;padding-left: 8px;padding-right: 8px;";
            el.className = "column-header column-header-".concat(props.columnInfo.column);
            el.title = "".concat(columnInfo.header);
            var text = el.appendChild(document.createElement("span"));
            text.style.cssText =
                "overflow: hidden;text-overflow: ellipsis;white-space: nowrap;";
            text.textContent = "".concat(columnInfo.header);
            if (props.columnInfo.sortable) {
                var link_1 = el.appendChild(document.createElement("button"));
                link_1.className = "sort-icon";
                link_1.innerHTML = sort;
                link_1.addEventListener("click", function (event) {
                    // Remettre tous les boutons de tri à zero
                    var allSort = document.getElementsByClassName("sort-icon");
                    Array.from(allSort).forEach(function (l) { return (l.innerHTML = sort); });
                    link_1.innerHTML = columnInfo.sortOrder === "desc" ? sortDown : sortUp;
                    setOrderBy(colName);
                    setSortedParams(columnInfo.sortOrder);
                    event.preventDefault();
                    event.stopPropagation();
                    if (columnInfo.sortOrder === "asc") {
                        columnInfo.sortOrder = "desc";
                    }
                    else {
                        columnInfo.sortOrder = "asc";
                    }
                });
            }
            this.el = el;
        }
        GetHeaderClass.prototype.getElement = function () {
            return this.el;
        };
        GetHeaderClass.prototype.render = function (props) { };
        return GetHeaderClass;
    }());
    /**--------------------------------------------------------- */
    /**Column pour grid*/
    var columnsGrid = useMemo(function () {
        var c = [];
        var buttons = [
            "edit_button",
            "remove_button",
            "del_button",
            "close_button",
        ];
        if (data && Array.isArray(data) && data.length > 0) {
            Object.entries((meta === null || meta === void 0 ? void 0 : meta.fields) || {}).forEach(function (_a, index) {
                var key = _a[0], value = _a[1];
                var width = value.width
                    ? parseInt(value.width.replace("%", "")) * 10
                    : 100;
                // Récupérer l'élément correspondant dans 'data' par index
                var item = data[index];
                var moduleName = (item === null || item === void 0 ? void 0 : item.module_name) || ""; // Récupérer 'module_name'
                c.push({
                    header: mod_strings[value.vname] ||
                        t(value.vname) ||
                        translateLabel(value.vname, tUnsafe, moduleName) ||
                        value.vname,
                    width: width,
                    id: key,
                    typeRender: (buttons === null || buttons === void 0 ? void 0 : buttons.includes(key)) ? "custom" : "text",
                    name: key,
                    moduleName: moduleName,
                });
            });
        }
        return c;
    }, [meta, t, data]);
    /** Taille de la page */
    var divRef = useRef(null);
    var _r = useState(0), pageWidth = _r[0], setPageWidth = _r[1];
    var updateWidth = function () {
        if (divRef.current) {
            var width = divRef.current.getBoundingClientRect().width;
            setPageWidth(width);
        }
    };
    useEffect(function () {
        updateWidth();
        window.addEventListener("resize", updateWidth);
        return function () {
            window.removeEventListener("resize", updateWidth);
        };
    }, [divRef.current]);
    /**------------------------- */
    var btnGroup = ["edit_button", "remove_button", "close_button"];
    /** realCols pour Grid */
    /*const realColsGrid = useMemo(() => {
      const cols: any = [];
  
      if (pageWidth === 0) return columnsGrid
  
      const fixedWidth = btnGroup.length * 30;
  
      // Largeur disponible pour les colonnes ajustables
      const availableWidth = pageWidth - fixedWidth;
  
      // Calcul des colonnes ajustables
      const adjustableColumns = columnsGrid.filter(
        (row: any) => !btnGroup.includes(row.name)
      );
  
      const totalInitialWidth = adjustableColumns.reduce(
        (sum: number, col: any) => sum + col.width,
        0
      );
  
      // Calcul du reste à distribuer
      const remainingWidth = availableWidth - totalInitialWidth;
      const additionalWidthPerColumn = remainingWidth / adjustableColumns.length;
  
      columnsGrid.forEach((row: any) => {
        const columnWidth = btnGroup.includes(row.name)
          ? 30 // Fixed width for btnGroup columns
          : row.width + additionalWidthPerColumn; // Adjusted width for other columns
  
        cols.push({
          name: row.name,
          sortingType: "asc",
          header: row.header,
          //width: btnGroup.includes(row.name) ? 30 : row.width,
          width: columnWidth,
          align: btnGroup.includes(row.name) ? "center" : "left",
          hasMenu: !btnGroup.includes(row.name),
          renderer:
            row.typeRender === "custom" ? ButtonCellRenderer : CellRendererClass,
        });
      });
  
      return cols;
    }, [columnsGrid, pageWidth]);*/
    var realColsGrid = useMemo(function () {
        if (pageWidth === 0)
            return columnsGrid;
        var totalFixedWidth = btnGroup.length * 30; // Largeur fixe des colonnes btnGroup
        var totalVariableWidth = 0;
        var adjustableColumns = columnsGrid.filter(function (col) { return !btnGroup.includes(col.name); });
        adjustableColumns.forEach(function (col) {
            totalVariableWidth += col.width;
        });
        var adjustedColumns = columnsGrid.map(function (col) {
            var BtnGroupColumnsCount = columnsGrid.filter(function (c) {
                return btnGroup.includes(c.name);
            }).length;
            var fixeWidth = BtnGroupColumnsCount * 30;
            if (btnGroup.includes(col.name)) {
                return __assign(__assign({}, col), { width: 30 });
            }
            var nonBtnGroupColumnsCount = columnsGrid.filter(function (c) { return !btnGroup.includes(c.name); }).length;
            var adjustCol = (pageWidth - fixeWidth - totalVariableWidth) / nonBtnGroupColumnsCount;
            return __assign(__assign({}, col), { width: col.width + adjustCol });
        });
        var cols = adjustedColumns.map(function (col) { return ({
            name: col.name,
            sortingType: "asc",
            header: col.header,
            width: col.width,
            align: btnGroup.includes(col.name) ? "center" : "left",
            hasMenu: !btnGroup.includes(col.name),
            renderer: col.typeRender === "custom" ? ButtonCellRenderer : CellRendererClass,
        }); });
        return cols;
    }, [columnsGrid, pageWidth]);
    var complexColumnPrefix = "complex_";
    useEffect(function () {
        var header = {
            complexColumns: [],
        };
        var arrayWidth = [];
        realColsGrid.forEach(function (c) {
            var _a, _b;
            arrayWidth.push(c.width);
            var heads = ["edit_button", "remove_button", "close_button", "email1"];
            var headsbutton = ["edit_button", "remove_button", "close_button"];
            var isButtonExcluded = headsbutton.includes(c.name);
            var isExcluded = heads.includes(c.name);
            var columnName = "".concat(complexColumnPrefix).concat(c.name);
            header.complexColumns.push({
                header: isButtonExcluded ? "" : c.header,
                name: isButtonExcluded ? "" : columnName,
                childNames: [c.name],
                headerAlign: "center",
                headerVAlign: "middle",
                headerRenderer: GetHeaderClass,
                resizable: true,
                hideChildHeaders: true,
                sortOrder: "asc",
                sortable: !isExcluded &&
                    (((_a = field_defs[c.name]) === null || _a === void 0 ? void 0 : _a.sortable) !== undefined
                        ? (_b = field_defs[c.name]) === null || _b === void 0 ? void 0 : _b.sortable
                        : true),
            });
        });
        tuiref.current && (tuiref === null || tuiref === void 0 ? void 0 : tuiref.current.gridInst.setHeader(header));
        var totalColumnWidth = realColsGrid.reduce(function (sum, col) { return sum + col.width; }, 0);
        /*const totalColumnWidth = arrayWidth.reduce(
          (partialSum, width) => partialSum + width,
          0
        );*/
        /*tuiref.current &&
          tuiref?.current.gridInst.setWidth(
            arrayWidth.reduce((partialSum, a) => partialSum + a, 0) + 100 || 1500
          );*/
        tuiref.current && tuiref.current.gridInst.setWidth(pageWidth);
    }, [realColsGrid, tuiref.current, pageWidth]);
    /**Record pour grid */
    var dataTuiGrid = useMemo(function () {
        var tuiDataList = data === null || data === void 0 ? void 0 : data.map(function (item) {
            var temp2 = {};
            Object.keys((meta === null || meta === void 0 ? void 0 : meta.fields) || {}).forEach(function (field) {
                if (field === "edit_button" ||
                    field === "remove_button" ||
                    field === "close_button") {
                    temp2[field] =
                        field === "edit_button"
                            ? "Editer"
                            : field === "remove_button"
                                ? "Supprimer"
                                : "Fermer";
                }
                else {
                    temp2[field] = item[field] === undefined ? "" : item[field];
                }
            });
            return temp2;
        });
        return tuiDataList;
    }, [data]);
    // Variable pour ouvrir/fermer un panneau
    var _s = useState(false), open = _s[0], setOpen = _s[1];
    useEffect(function () {
        data && (data === null || data === void 0 ? void 0 : data.length) > 0 && setOpen(true);
    }, [data]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    useEffect(function () {
        dispatch(setWidgetDisplay(true));
    }, []);
    var _t = usePopup(), showPopup = _t.showPopup, closePopup = _t.closePopup;
    // Delete id
    var deleteRelationMutaion = useDeleteRelationshipMutation()[0];
    var _u = useState(false), load = _u[0], setLoad = _u[1];
    var deleteRelationship = function (m, recId) { return __awaiter(_this, void 0, void 0, function () {
        var result, updatedData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setLoad(true);
                    return [4 /*yield*/, deleteRelationMutaion({
                            module: moduleName,
                            body: {
                                ids: [recId],
                                record: recordId,
                                linkedField: m,
                                subpanelID: subpanelId,
                            } || [],
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    if (result) {
                        if (result.data.deleted === "ok") {
                            toast.success(t("app.LBL_RELATION_DELETED", {
                                ns: "common",
                            }));
                            updatedData = data.filter(function (item) { return item.id !== recId; });
                            //setSubpanelData(updatedData);
                            if (updatedData.length === 0) {
                                setNewRecord([]);
                                setLoad(false);
                                setOpen(false);
                            }
                        }
                        else {
                            toast.error(t("app.LBL_RELATION_NOT_DELETED", {
                                ns: "common",
                            }));
                        }
                    }
                    setLoad(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    setLoad(false);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _v = useState(false), isCreateOn = _v[0], setIsCreateOn = _v[1];
    var buttonsCreate = [
        {
            text: "Save",
            className: "button success",
            onClick: function () { return saveRecord(); },
        },
        {
            text: "Cancel",
            className: "button secondary",
            onClick: function () {
                setIsCreateOn(false);
                setEditedRecord([]);
            },
        },
        {
            text: "Full_form",
            className: "button secondary",
            onClick: function () {
                var hiddenData = {
                    relatedId: recordId,
                    relatedModuleName: moduleName,
                };
                navigate("/modules/".concat(mModule, "/EditView"), { state: hiddenData });
            },
        },
    ];
    var GroupButtons = function () {
        return (_jsx("div", __assign({ className: " flex text-white font-medium" }, { children: buttonsCreate.map(function (button, index) { return (_jsx("div", { children: _jsx("button", __assign({ className: button.className, onClick: button.onClick }, { children: t("app.LBL_".concat(button.text.toUpperCase(), "_BUTTON_LABEL"), {
                        ns: "common",
                    }) }), index) })); }) })));
    };
    var record = {};
    var listFields = useGetModuleFieldsQuery(subModule || "Accounts").data;
    var field_defs = (listFields && (listFields === null || listFields === void 0 ? void 0 : listFields.data.attributes)) || [];
    var _w = useGetModuleBuilderLayoutQuery({
        moduleName: mModule || "Accounts",
        layout: "quickcreatedefs",
    }), viewDefs = _w.data, isFetching = _w.isFetching;
    var view_defs = viewDefs || {};
    var viewDefsData = view_defs.data || {};
    var layoutMeta = viewDefsData.layout || {};
    //SAVE
    var _x = useState(copy(record)), editedRecord = _x[0], setEditedRecord = _x[1];
    var _y = useState(new Map()), validations = _y[0], setValidations = _y[1];
    var updateRecord = function (edited) {
        setEditedRecord(edited);
    };
    var _z = mapFieldMetaData(layoutMeta.layout, field_defs), filteredFieldsDefs = _z[0], fieldMetadataMap = _z[1];
    var validationRules = useMemo(function () {
        var validationRules = new Map();
        fieldMetadataMap.forEach(function (field, fieldName) {
            //check if field is email
            var controls = field.type === undefined || field.type === ""
                ? []
                : fieldName === "email1"
                    ? "email"
                    : field.type;
            var rules = Array.isArray(controls) ? controls : [controls];
            if (field.required && !["boolean"].includes(field.type || "")) {
                rules.push("mandatory");
            }
            var er = /^-?[0-9]+$/;
            if (field.len && er.test(field.len)) {
                rules.push("max:".concat(field.len));
            }
            if (field.validation && field.validation.type === "range") {
                rules.push("between:".concat(field.validation.min, ":").concat(field.validation.max));
            }
            if (rules.length <= 0) {
                return;
            }
            validationRules.set(fieldName, rules);
        });
        return validationRules;
    }, [fieldMetadataMap]);
    var validate = useCallback(function () {
        var result = validateRecord(editedRecord, fieldMetadataMap, validationRules, t);
        setValidations(result);
        return result;
    }, [editedRecord, fieldMetadataMap, setValidations, t, validationRules]);
    var _0 = useState(), displayValidationResult = _0[0], setDisplayvalidationResult = _0[1];
    var _1 = useState(0), key = _1[0], setKey = _1[1];
    // Enregistrement record
    var _2 = useSaveRecordMutation(), saveRecordMutaion = _2[0], _3 = _2[1], saveData = _3.data, tokenAccessError = _3.error, isLoadSave = _3.isLoading;
    var saveRecord = function () { return __awaiter(_this, void 0, void 0, function () {
        var validationResult, result, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    validationResult = validate();
                    setDisplayvalidationResult(validationResult);
                    if (validationResult.size > 0) {
                        logger.error("L'enregistrement ne peut \u00EAtre enregistr\u00E9 tant qu'il y a des erreurs au niveau des champs.");
                        logger.error("Erreur validation", validationResult);
                        return [2 /*return*/];
                    }
                    setDisplayvalidationResult(null);
                    return [4 /*yield*/, saveRecordMutaion({
                            body: {
                                module: mModule,
                                record: editedRecord,
                                relatedModuleName: moduleName,
                                relatedId: recordId,
                            } || {},
                        }).unwrap()];
                case 1:
                    result = _a.sent();
                    setKey(function (prev) { return prev + 1; });
                    return [4 /*yield*/, refetch()];
                case 2:
                    _a.sent();
                    setEditedRecord([]);
                    toast.success(t("app.LBL_RECORD_SAVED", {
                        ns: "common",
                    }));
                    setIsCreateOn(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.log(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var bodyHeight = useMemo(function () {
        // Nombre de lignes dans dataTuiGrid
        var numberOfRows = (data === null || data === void 0 ? void 0 : data.length) || 0;
        return Math.max(numberOfRows * 20, 20); // Hauteur totale du corps du tableau
    }, [data]);
    var _4 = useState(false), isMoreSubModuelCliked = _4[0], setIsMoreSubModuelCliked = _4[1];
    var dropdownInputRef = useRef(null);
    var handleClickOutside = function (event) {
        if (dropdownInputRef.current &&
            !dropdownInputRef.current.contains(event.target)) {
            setIsMoreSubModuelCliked(false);
        }
    };
    useEffect(function () {
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var button = topButtons && ((_f = topButtons[0]) === null || _f === void 0 ? void 0 : _f.widget_class);
    var extracted = button && button.replace("SubPanelTopCreate", "").replace("Button", "");
    var btncreateGroupModule = extracted + "s";
    TuiGrid.applyTheme("default", tableOptions);
    var addRelationship = function (selectedRecords) { return __awaiter(_this, void 0, void 0, function () {
        var _i, selectedRecords_1, record_1, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    _i = 0, selectedRecords_1 = selectedRecords;
                    _a.label = 1;
                case 1:
                    if (!(_i < selectedRecords_1.length)) return [3 /*break*/, 4];
                    record_1 = selectedRecords_1[_i];
                    return [4 /*yield*/, saveRecordMutaion({
                            body: {
                                module: record_1.module_name,
                                record: record_1,
                                relatedModuleName: moduleName,
                                relatedId: recordId,
                            },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    toast.success("".concat(selectedRecords.length, " record(s) linked successfully"));
                    closePopup("null", "null");
                    return [3 /*break*/, 6];
                case 5:
                    error_3 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var saveNewRecord = function (payload, module) { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    // 🔥 Call your SuiteCRM API to create the record
                    return [4 /*yield*/, saveRecordMutaion({
                            body: {
                                module: module,
                                record: payload,
                                relatedModuleName: moduleName,
                                relatedId: recordId,
                            },
                        }).unwrap()];
                case 1:
                    // 🔥 Call your SuiteCRM API to create the record
                    _a.sent();
                    toast.success("Saved successfully");
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error("Record creation failed:", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var callbackId = "addRelationship_".concat(Date.now());
    popupCallbackRegistry[callbackId] = function (selectedIds) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addRelationship(selectedIds)];
                case 1:
                    _a.sent();
                    refetch();
                    return [2 /*return*/];
            }
        });
    }); };
    var saveCallbackId = "saveRecord_".concat(Date.now());
    popupCallbackRegistry[saveCallbackId] = function (recordData, moduleName) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, saveNewRecord(recordData, moduleName)];
                case 1:
                    _a.sent(); // your existing save logic
                    refetch(); // refresh subpanel data
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "relative\n    pt-[var(--padding-pt-subpanel)] pr-[var(--padding-pr-subpanel)]\n    pb-[var(--padding-pb-subpanel)] pl-[var(--padding-pl-subpanel)]" }, { children: [(isLoading || load || isLoadSave || isFetchingSubpanel) && (_jsx(LoaderImage, {})), _jsxs("div", __assign({ ref: divRef, className: "flex justify-between w-full ".concat(!useTab ? "py-4" : "", " bg-[var(--colors-subpanel-bg)] border-2 border-gray-50") }, { children: [_jsx("button", __assign({ onClick: function () {
                            setOpen(!open);
                            !open && setIsCreateOn(false);
                        } }, { children: _jsxs("div", __assign({ className: "flex flex-row items-center justify-center text-[var(--colors-subpanel)]" }, { children: [_jsx("span", { children: !open ? (_jsx(FontAwesomeIcon, { icon: faChevronDown })) : (_jsx(FontAwesomeIcon, { icon: faChevronUp })) }), !useTab && (_jsxs("h3", __assign({ className: "uppercase pl-2 flex-grow" }, { children: [(subpanelMeta.title_key &&
                                            t(subpanelMeta.title_key, {
                                                ns: moduleName,
                                            })) ||
                                            (parentModuleStrings &&
                                                parentModuleStrings[subpanelMeta.title_key]) ||
                                            (moduleStrings && moduleStrings[subpanelMeta.title_key]), " "] })))] })) })), open && !isCreateOn && topButtons && topButtons.length > 0 && (_jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx(Pagination, { totalResult: list === null || list === void 0 ? void 0 : list.length, elementPerPage: perPage, currentPage: currentPage, onChangePagination: function (event) { return handlePagination(event); } }), _jsxs("div", __assign({ ref: dropdownInputRef, className: "flex items-center w-[100px] ".concat(((_g = meta === null || meta === void 0 ? void 0 : meta.topButtonsModule) === null || _g === void 0 ? void 0 : _g.length) > 0 && "w-[200px]", "  border rounded-sm border-gray-300 ") }, { children: [_jsxs("button", __assign({ style: {
                                            background: "none",
                                            // border: "1px solid var(--color-gray-200)", // Décommentez si nécessaire
                                            //color: "var(--color-gray-500)",
                                            color: "var(--colors-subpanel)",
                                            paddingTop: "0",
                                            paddingBottom: "0",
                                            marginLeft: "2%",
                                            marginRight: "2%",
                                            width: "100%",
                                        }, className: " hover:bg-[rgb(var(--color-blue-500))] hover:text-white font-medium flex items-center", onClick: function (e) {
                                            var _a;
                                            //e.stopPropagation();
                                            e.preventDefault();
                                            setIsCreateOn(true);
                                            setSubModule(((_a = meta === null || meta === void 0 ? void 0 : meta.topButtonsModule) === null || _a === void 0 ? void 0 : _a.length) > 0
                                                ? btncreateGroupModule
                                                : mModule);
                                        } }, { children: [_jsx(FontAwesomeIcon, { icon: faAdd, className: "m-1" }), (meta === null || meta === void 0 ? void 0 : meta.topButtonsModule[0])
                                                ? t("app.LBL_CREATE_".concat(btncreateGroupModule.endsWith("s")
                                                    ? btncreateGroupModule.slice(0, -1).toUpperCase()
                                                    : btncreateGroupModule.toUpperCase()), { ns: "common" }).toUpperCase()
                                                : t("app.LBL_CREATE_BUTTON_LABEL", {
                                                    ns: "common",
                                                }).toUpperCase()] })), _jsx(FontAwesomeIcon, { icon: faCaretDown, className: " bg-gray-200 py-3 px-1.5 cursor-pointer dark:bg-[var(--colors-subpanel-bg)] text-[var(--colors-subpanel)]", onClick: function (e) {
                                            setIsMoreSubModuelCliked(!isMoreSubModuelCliked);
                                        } }), isMoreSubModuelCliked && (_jsx("div", __assign({ className: "z-[20] absolute top-12 mt-1 w-[200px]  bg-white border border-gray-200 shadow-lg rounded-md dark:bg-[var(--colors-subpanel-bg)] dark:text-[var(--colors-subpanel)]" }, { children: _jsx("ul", __assign({ className: " p-1 dark:bg-[rgb(var(--color-gray-900))] ".concat(((_h = meta === null || meta === void 0 ? void 0 : meta.topButtonsModule) === null || _h === void 0 ? void 0 : _h.length) >= 8 &&
                                                "h-80 overflow-auto") }, { children: (meta === null || meta === void 0 ? void 0 : meta.topButtonsModule.length) > 0 ? (meta.topButtonsModule.map(function (item, index) {
                                                return item === btncreateGroupModule ? null : ( // Skip rendering if item is "btncreateGroupModule"
                                                _jsx("li", __assign({ className: "cursor-pointer p-1 hover:bg-gray-100 dark:hover:bg-[rgb(var(--color-gray-800))] dark:text-[rgb(var(--color-gray-100))]", onClick: function () {
                                                        setSubModule(item || "Accounts");
                                                        setIsCreateOn(true);
                                                        setIsMoreSubModuelCliked(false);
                                                    } }, { children: t("app.LBL_".concat(item.toUpperCase()), {
                                                        ns: "common",
                                                    }) }), index));
                                            })) : (_jsx("li", __assign({ className: "cursor-pointer p-1 hover:bg-gray-100", onClick: function () {
                                                    return showPopup({
                                                        type: "widget/selectorSubpanel",
                                                        payload: {
                                                            subModule: subModule || "Accounts",
                                                            parentModuleName: moduleName,
                                                            parentRecordId: recordId,
                                                            field_defs: field_defs,
                                                            create_layout: layoutMeta,
                                                            multiple: true,
                                                            callbackId: callbackId,
                                                            saveCallbackId: saveCallbackId,
                                                        },
                                                    });
                                                } }, { children: t("app.LBL_SELECT_BUTTON_LABEL", { ns: "common" }) }))) })) })))] }))] })))] })), open && (_jsx(_Fragment, { children: !isCreateOn ? (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "custom-grid-container" }, { children: dataTuiGrid && dataTuiGrid.length > 0 ? (_jsx(Grid, { ref: tuiref, bodyHeight: bodyHeight, width: 1500, scrollX: true, columns: realColsGrid, data: dataTuiGrid })) : (_jsx("div", __assign({ className: "h-[100px] bg-[#f4f4ff] flex items-center justify-center w-full text-[rgb(var(--color-gray-500))] " }, { children: t("app.LBL_NO_DATA") }))) })) })) : (_jsxs("div", __assign({ className: "px-6" }, { children: [_jsx(GroupButtons, {}), _jsx("div", { children: field_defs && layoutMeta && (_jsx(LayoutComponentDisplay, { module: subModule || "Accounts", viewType: FieldViewType.EDIT, record: editedRecord, fetchedRecord: editedRecord, layouts: layoutMeta.layout, fieldDefs: field_defs, viewScreen: screenViewType.EDITVIEW, onHandleUpdate: updateRecord, validations: validations })) }), _jsx(GroupButtons, {})] }))) }))] }), "subpanel-".concat(key)));
}
/**
 * Pagination d'un tableau
 * @param array
 * @param page_size : nombre par page
 * @param page_number : première position
 * @returns
 */
function paginate(array, page_size, page_number) {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
}
